import { render } from "./AppExternalLauncher.vue?vue&type=template&id=8565d2ec&scoped=true&ts=true"
import script from "./AppExternalLauncher.vue?vue&type=script&lang=ts"
export * from "./AppExternalLauncher.vue?vue&type=script&lang=ts"

import "./AppExternalLauncher.vue?vue&type=style&index=0&id=8565d2ec&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8565d2ec"]])

export default __exports__